import styled from 'styled-components';

export const Wrapper = styled.div<{
  width: number;
  height: number;
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${props => props.width}px;
  height: ${props => props.height}px;
  background: #f6fcf9;
  border-radius: ${props => props.theme.radius.md};
`;
